import styled from "styled-components";
import { Section, Container } from "../../sdk/Layout";

export const ContainerExtended = styled(Container)`
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    max-width: 320px !important;
    overflow: hidden;
    p {
        max-width: 320px;
        margin: auto;
        color: ${props => props.theme.primaryDark};
        a {
            color: ${props => props.theme.link};
            cursor: pointer;
        }
    }
    button {
        margin-top: 20px;
    }

    &--extended {
        p {
            max-width: 500px;
        }
        .button-blue {
            margin: 20px auto;
        }
    }
`;
